import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import UpdateLeadForm from '../../forms/UpdateLeadForm';
import { addLeadAction, getLeadData } from '../../util/api';
import LeadTable from "../dumb/LeadTable";
import LoadingModal from '../dumb/LoadingModal';

function LeadComponent({ filter }) {
  const [ leadData, setLeadData ] = useState({ data: [], columns: [] });
  const [ loading, setLoading ] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [context, setContext] = useState({ });
  const [refresh, setRefresh] = useState(true);
  const history = useHistory();

  useEffect(() => {
    setLoading(true);
    getLeadData(filter)
      .then(({ data, columns }) => {
        setLeadData({ data, columns });
        setLoading(false);
      })
      .catch((error) => {
        console.log(`error = ${error}`);
        setLoading(false);
      })
  }, [filter, refresh]);

  return (
    <>
      <LeadTable
        data={leadData.data}
        columns={leadData.columns}
        updateLead={({ leadId, name, email, leadStage, currentExperience, currentProfession, currentIndustry }) => {
          setUpdateModal(true);
          setContext({ leadId, name, email, leadStage, leadProfile: { currentExperience, currentProfession, currentIndustry } });
        }}
        viewLead={({ leadId }) => {
          window.open(`https://prepfortech-sales.netlify.app/lead/info/${leadId}`, '_blank', 'noopener,noreferrer');
          // history.push(`/lead/info/${leadId}`);
        }}
      />
      {
        updateModal === true
        && (
          <UpdateLeadForm
            leadId = {context.leadId}
            name={context.name}
            email={context.email}
            leadStage={context.leadStage}
            leadProfile={context.leadProfile}
            hideModal={() => setUpdateModal(false)}
            onSubmit={(update, leadStage, actionType, demoDate, callResult, currentIndustry, currentExperience,
                       currentProfession) => {
              setLoading(true);
              addLeadAction(context.leadId, { update, leadStage, actionType, demoDetails: { demoDate }, callResult,
                currentIndustry, currentExperience, currentProfession })
                .then(() => {
                  setLoading(false);
                  setUpdateModal(false);
                  setRefresh(!refresh);
                })
                .catch((error) => {
                  console.log(`error = ${error}`);
                  setLoading(false);
                })
            }}
          />
        )
      }
      {
        loading === true
        && (
          <LoadingModal />
        )
      }
    </>
  );
}

export default LeadComponent;
